// extracted by mini-css-extract-plugin
export default {"renderer":"av_0G"};